import script from "./Policy.vue?vue&type=script&setup=true&lang=ts"
export * from "./Policy.vue?vue&type=script&setup=true&lang=ts"

import "./Policy.vue?vue&type=style&index=0&id=e46780ae&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e46780ae"]])

export default __exports__